export const SWR_OPTIONS = {
  revalidateOnMount: true,
  errorRetryCount: 2,
}
